import React, { Component, Fragment, Suspense, lazy } from 'react'
import { ConnectedRouter } from 'connected-react-router'
import { connect } from 'react-redux'
import { Switch } from 'react-router-dom'
import avatar8 from 'src/assets/brand/preloader.webp'
import RoutePrivate from './components/RoutePrivate'
import RoutePublic from './components/RoutePublic'
import { GetSetting } from './store/actions/getSetting'

// import Invoice from './views/Invoice'
import Redirector from './components/Redirect'
// import Payment from './containers/Payments/NewPayment'
// import BroadcastFloatingPanel from './views/WhatsApp/KirimPesanBlastForm/BroadCastFloatPanel'
// import ProcessPanel from "src/components/ProgressPanel/ProcessPanel";
// import NotificationToast from './components/Notification/NotificationToast'
// import NotificationPermission from './components/Notification/NotificationPermission'
// // import deviceService from './services/deviceService'
// import { initializeDevice } from './store/actions/deviceAction'
// import LockScreen from './components/LockScreen'
import IdleManager from "./services/IdleManager"

import './scss/style.scss'

const LockScreen = React.lazy(() => import(/* webpackPrefetch: true */ './components/LockScreen'))
const Invoice = React.lazy(() => import(/* webpackPrefetch: true */ './views/Invoice'))
const Payment = React.lazy(() => import(/* webpackPrefetch: true */ './containers/Payments/NewPayment'))
const ProcessPanel = React.lazy(() => import(/* webpackPrefetch: true */ 'src/components/ProgressPanel/ProcessPanel'))
const BroadcastFloatingPanel = React.lazy(() => import(/* webpackPrefetch: true */ './views/WhatsApp/KirimPesanBlastForm/BroadCastFloatPanel'))
const NotificationToast = React.lazy(() => import(/* webpackPrefetch: true */ './components/Notification/NotificationToast'))
const NotificationPermission = React.lazy(() => import(/* webpackPrefetch: true */ './components/Notification/NotificationPermission'))
// import { getNotificationPermission } from './services/firebase'






// Konstanta untuk status
const STATUS = {
  RUNNING: 'running',
  ERROR: 'error',
  SUCCESS: 'success'
}

// Loading Component
export const SupendLoading = () => (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Web Storage helper
const StorageHelper = {
  getAuthToken: () => {
    if (typeof localStorage !== 'undefined') {
      return localStorage.getItem('authToken')
    }
    if (typeof sessionStorage !== 'undefined') {
      return sessionStorage.getItem('authToken')
    }
    console.warn('Web Storage is not supported in this environment.')
    return null
  },

  setAuthToken: (token) => {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('authToken', token)
    } else if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem('authToken', token)
    }
  },

  clearAuthToken: () => {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('authToken', '')
    }
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem('authToken', '')
    }
  }
}

const LoadingW = ({ status }) => {
  return (
    <div className="preloader-wrapper">
      <div className='d-block'>
        <img
          src={avatar8}
          type='image/webp'
          style={{ scale: "2" }}
          alt="Loading..."
        />
        {/* Status messages can be uncommented if needed */}
        {/* {status === STATUS.RUNNING && <i>Pengecekan Server..</i>} */}
        {/* {status === STATUS.ERROR && <small>Server galat</small>} */}
      </div>
      <br />
    </div>
  )
}

// Lazy loaded components dengan prefetch
const DefaultLayout = lazy(() =>
  import(/* webpackPrefetch: true */ './layout/DefaultLayout.js')
)
const Login = lazy(() =>
  import(/* webpackPrefetch: true */ './views/pages/login/Login.js')
)
const TwoFA = lazy(() =>
  import(/* webpackPrefetch: true */ './views/pages/2fa/index.js')
)
const Page404 = lazy(() =>
  import(/* webpackPrefetch: true */ './views/pages/page404/Page404')
)

class App extends Component {
  constructor(props) {
    super(props)
    this.retryTimeout = null
    this.idleTimer = null

    this.state = {
      isShowErrorMessage: false,
      cssLoaded: false
    }
  }

  initializeIdleSystem = () => {

    const { app_setting, history, users } = this.props

    if (!users?.isAuthenticated) return

    const settings = app_setting?.response?.lock_screen

    if (!settings?.enable_lock) return

    const timeout = settings.idle_minutes * 60 * 1000

    IdleManager.init({
      timeout,
      history
    })

  }

  initializeApp = () => {
    const { dispatch, users, app_setting } = this.props
    const { response } = app_setting

    const hasFcmToken = users?.deviceStatus?.hasFcmToken
    const isLoggedIn = users?.deviceStatus?.isLoggedIn

    // console.log(users?.deviceStatus)

    // Handle unauthorized response
    if (response && response === 'Unauthorized') {
      StorageHelper.clearAuthToken();
      return;
    }

    // console.log(app_setting)

    // console.log(users)
    /* hanya level access reseller yang berhak menerima notif */
    const is_teknisi = [5]
    const is_reseller = [3] /* reseller dan teknisi */
    // Jangan jalankan proses aplikasi jika belum login.
    if (!users?.isAuthenticated) {
      return;
    }


    // Load settings if authenticated and not on payment page
    if (users.isAuthenticated) {
      const path = window.location?.pathname
      if (!path.includes("payment")) {
        // alert("dari sinih setelah auth")
        dispatch(GetSetting())
        // deviceService.handleAppStart(users.id);
        /* prioritasikan pengaturan default nya  */
        // if (response?.user_config?.push_notifications === 1) {
        //   const permission = getNotificationPermission()
        //   const hasToken = hasFcmToken;

        //   if (is_reseller.includes(Profile?.level_access) && permission === 'granted' && hasToken) {
        //     if (!isLoggedIn)
        //       dispatch(initializeDevice())
        //   }
        //   if (is_teknisi.includes(Profile?.level_access) &&
        //     Profile?.permissions?.management_notifikasi && permission === 'granted' && hasToken) {
        //     if (!isLoggedIn)
        //       dispatch(initializeDevice())
        //   }
        // }

      }
    }
  }



  retryGetSetting = () => {
    const { dispatch } = this.props
    dispatch(GetSetting())
  }

  componentDidMount() {
    this.initializeApp()
  }

  componentDidUpdate(prevProps) {
    const { app_setting, users } = this.props
    const { status } = app_setting
    const wasAuthenticated = prevProps.users?.isAuthenticated;
    const isAuthenticated = this.props.users?.isAuthenticated;

    // Jalankan hanya ketika berubah dari belum login
    // menjadi sudah login.
    if (!wasAuthenticated && isAuthenticated) {
      this.initializeApp();
    }


    if (app_setting !== prevProps.app_setting) {
      if (status === STATUS.ERROR) {
        this.setState({ isShowErrorMessage: true })
        // alert("dari sinih 2")
        this.retryTimeout = setTimeout(() => {
          this.retryGetSetting()
        }, 5000)
      }

      if (status === STATUS.SUCCESS) {
        this.setState({ isShowErrorMessage: false })
        this.initializeIdleSystem()
      }
    }
  }



  componentWillUnmount() {
    if (this.retryTimeout) {
      clearTimeout(this.retryTimeout)
    }
  }


  renderRoutes = () => {
    const { users, app_setting } = this.props

    return (
      <Switch>
        {/* Public Routes */}
        <RoutePublic
          isAuthenticated={users?.isAuthenticated}
          is2FARequired={users?.is2FARequired}
          is2FAVerified={users?.is2FAVerified}
          path="/login"
          exact
          component={Login}
        />

        <RoutePublic
          isAuthenticated={users?.isAuthenticated}
          is2FARequired={users?.is2FARequired}
          is2FAVerified={users?.is2FAVerified}
          path="/2fa"
          exact
          component={TwoFA}
        />

        <RoutePublic
          isAuthenticated={false}
          path="/lock-screen"
          exact
          component={LockScreen}
          appSetting={app_setting.response}
        />

        <RoutePublic
          isAuthenticated={false}
          path="/invoices"
          exact
          component={Invoice}
        />

        <RoutePublic
          isAuthenticated={false}
          path="/payment/:id_invoice"
          exact
          component={Payment}
        />

        <RoutePublic
          isAuthenticated={false}
          path="/redirect"
          exact
          component={Redirector}
        />

        {/* Private Route - Main Layout */}
        <RoutePrivate
          isAuthenticated={users?.isAuthenticated}
          twoFAEnabled={users?.is2FARequired}
          twoFAVerified={users?.is2FAVerified}
          path="/"
          component={DefaultLayout}
          to="/login"
          appSetting={app_setting.response}
        />

        {/* 404 Route */}
        <RoutePublic
          isAuthenticated={false}
          path="*"
          component={Page404}
        />
      </Switch>
    )
  }

  render() {
    const { app_setting } = this.props
    const { isShowErrorMessage } = this.state

    // console.log(this.props)

    const isPageLogin = this.props?.history.location.pathname

    if (isShowErrorMessage) {
      return <LoadingW status={app_setting.status} />
    }

    return (
      <Fragment>
        <ConnectedRouter history={this.props.history}>
          <Suspense fallback={<SupendLoading />}>
            <div>
              {/* Floating Panels */}
              <BroadcastFloatingPanel />
              {/* <LockScreen /> */}
              <ProcessPanel />
              <NotificationToast />

              {/* Notification Permission Banner */}
              {!isPageLogin && <NotificationPermission />}


              {/* Main Routes */}
              {this.renderRoutes()}
            </div>
          </Suspense>
        </ConnectedRouter>
      </Fragment>
    )
  }
}

// Selector untuk mapping state ke props
const mapStateToProps = (state) => ({
  users: state.authentication,
  Profile: state?.Profile?.response?.full,
  app_setting: {
    response: state.app_setting.response,
    status: state.app_setting.status,
  }
})

// Default props
App.defaultProps = {
  users: {
    isAuthenticated: false,
    is2FARequired: false,
    is2FAVerified: false
  },
  app_setting: {
    response: null,
    status: ''
  }
}

export default connect(mapStateToProps)(App)